<template>
    <SettingsPage title="Einstellung für Kartenreiter">
        <div id="setting-area">
            <div v-if="tabs.length > 0" id="select-current">
                <ul class="list-group">
                    <li
                        :key="'name_input_' + !currentTab.id"
                        :class="{
                            'list-group-item': true,
                            footer: true,
                            selected: !currentTab.id
                        }"
                    >
                        <b-button variant="primary" @click="resetCurrentTab()">
                            Neuer Kartenreiter
                        </b-button>
                    </li>
                    <li
                        v-for="(tab, index) in tabs"
                        :key="'draggable_tab_' + tab.id"
                        :class="{
                            'list-group-item': true,
                            'draggable-tab': true,
                            selected: tab.id === currentTab.id
                        }"
                        @click="selectTab(tab)"
                    >
                        <span class="tab-list-name">{{ tab.name }}</span>

                        <font-awesome-icon
                            v-if="tab.id !== currentTab.id"
                            class="list-group-sorter-start"
                            icon="sort"
                        />
                        <div v-else class="list-group-sorter-box">
                            <font-awesome-icon
                                v-if="index !== 0"
                                class="list-group-sorter"
                                icon="sort-up"
                                @click="changeOrder(index, 'up')"
                            />
                            <font-awesome-icon
                                v-if="index !== tabs.length - 1"
                                class="list-group-sorter"
                                icon="sort-down"
                                @click="changeOrder(index, 'down')"
                            />
                        </div>
                    </li>
                </ul>
            </div>
            <div v-else id="create-first">
                <p>
                    Mit Kartenreitern können Sie Artikel nach Ihren Anforderungen gruppieren.
                </p>
                <label>
                    <span>Name</span>
                    <b-form-input
                        v-model="currentTab.name"
                        placeholder="Name für den Kartenreiter"
                    />
                </label>
            </div>

            <div id="form" :key="'form_' + currentTab.id">
                <div class="form-row">
                    <label>
                        <span>Name des Kartenreiters:</span>
                        <b-input ref="tabNameInput" v-model="currentTab.name" />
                    </label>
                </div>
                <div class="form-row">
                    <label>
                        <span>Lagerort:</span>
                        <select v-model="currentTab.storageLocation" class="form-control">
                            <option :value="null" disabled selected>
                                Wählen Sie einen Lagerort aus
                            </option>
                            <option
                                v-for="(storageLocation, index) in storageLocations"
                                :key="'storage_' + index"
                                :value="storageLocation"
                            >
                                {{ storageLocation }}
                            </option>
                        </select>
                    </label>
                    <div>
                        <span>Hersteller:</span>
                        <SelectManufacturer v-model="currentTab.manufacturerId" single-select />
                    </div>
                </div>
                <div class="form-row">
                    <label>
                        <span>Warengruppe:</span>
                        <select v-model="currentTab.waregroup" class="form-control">
                            <option :value="null" disabled selected>
                                Wählen Sie eine Warengruppe aus
                            </option>
                            <option
                                v-for="(option, index) in waregroupName"
                                :key="'waregroup_' + index"
                                :value="option.waregroupstart"
                            >
                                {{ option.name }}
                            </option>
                        </select>
                    </label>
                    <label>
                        <span>oder</span>
                        <b-form-input
                            v-model="currentTab.waregroup"
                            placeholder="Hier Warengruppe eintragen"
                        />
                    </label>
                </div>
                <div class="form-row">
                    <SmartButton v-if="currentTab.id" variant="primary" @click="saveTabChanges()">
                        <span>Änderungen speichern</span>
                    </SmartButton>
                    <button v-else class="btn btn-primary" @click="saveTabCreate()">
                        <span>Kartenreiter erstellen</span>
                    </button>
                </div>
                <div v-if="currentTab.id" class="form-row">
                    <AreYouSure confirm-msg="Kartenreiter löschen!" @confirm="deleteTab()">
                        <b-button variant="danger">Kartenreiter löschen?</b-button>
                    </AreYouSure>
                </div>
            </div>
        </div>
    </SettingsPage>
</template>

<script>
import Data from "@/store/api/data/Data";

import SelectManufacturer from "@/views/shared/widgets/SelectManufacturer";
import AreYouSure from "@/views/shared/widgets/AreYouSure";
import SettingsPage from "./SettingsPage";
import SmartButton from "@/views/shared/widgets/SmartButton";

export default {
    name: "TabSettings",
    components: { SmartButton, SettingsPage, SelectManufacturer, AreYouSure },
    data: function() {
        return {
            changeOrderMode: false,
            defaultInput: {
                id: null,
                name: null,
                manufacturerId: null,
                storageLocation: null,
                waregroup: null,
                /* will always be null */
                testFunction: null
            },
            input: null,
            currentTab: null,
            storageLocations: [],
            waregroupName: [
                {
                    name: "Sonnenschutz",
                    waregroupstart: "BC04"
                },
                {
                    name: "Haut-, Körperpflege",
                    waregroupstart: "BC01D"
                },
                {
                    name: "Homöopathie/Biochemie",
                    waregroupstart: "BX01"
                },
                {
                    name: "Antihistaminika",
                    waregroupstart: "AR06"
                }
            ]
        };
    },
    computed: {
        tabs: {
            get() {
                return this.$store.state.tabs.tabs.filter(tab => tab && !tab.default);
            },
            set(value) {
                console.log("setTabs", value);
                this.$store.commit("setTabs", value);
            }
        }
    },
    created() {
        this.initData();
        this.resetCurrentTab();
        this.selectFirstTab();
    },
    methods: {
        initData() {
            this.$store.dispatch("getAllTabs");
            return Data.getStorageLocations().then(response => {
                this.storageLocations = response.data;
            });
        },
        findNextTab(searchTab) {
            const id = this.tabs.findIndex(tab => tab.id === searchTab.id);
            if (this.tabs[id + 1]) {
                return this.tabs[id + 1];
            } else if (this.tabs[id - 1]) {
                return this.tabs[id - 1];
            }
            return null;
        },
        selectFirstTab() {
            this.currentTab =
                this.tabs.filter(tab => !tab.default).length === 0
                    ? this.input
                    : this.tabs.filter(tab => !tab.default)[0];
        },
        resetCurrentTab() {
            this.input = { ...this.defaultInput };
            this.currentTab = { ...this.defaultInput };
            if (this.$refs.tabNameInput) {
                console.log(this.$refs.tabNameInput);
                // NO IDEA WARUM DAS NICHT KLAPPT
                this.$refs.tabNameInput.focus();
            }
            console.log("currentTab is now", this.currentTab);
        },
        async saveTabCreate() {
            await this.$store.dispatch("addPharmacyTab", this.currentTab).then(tab => {
                this.$store.dispatch("getAllTabs");
                this.resetCurrentTab();
                this.selectTab(tab);
            }, this);
        },
        async saveTabChanges() {
            return await this.$store
                .dispatch("changeCustomPharmacyTab", this.currentTab)
                .then(tab => {
                    this.$store.dispatch("getAllTabs");
                    this.selectTab(tab);
                }, this);
        },
        deleteTab() {
            const nextSelectedTab = this.findNextTab(this.currentTab);
            this.$store.dispatch("deleteCustomPharmacyTab", this.currentTab).then(() => {
                this.$store.dispatch("getAllTabs");
                this.selectTab(nextSelectedTab);
            }, this);
        },
        changeOrder(index, direction) {
            var target = undefined;
            var tempTabArray = this.tabs;
            var b = tempTabArray[index];

            switch (direction) {
                case "up":
                    if (index === 0) {
                        return;
                    }
                    target = index - 1;
                    break;
                case "down":
                    if (index === this.tabs.length) {
                        return;
                    }
                    target = index + 1;
            }

            tempTabArray[index] = tempTabArray[target];
            tempTabArray[target] = b;
            this.$store.commit("setTabs", tempTabArray);
            this.updateOrder();
        },
        updateOrder() {
            console.log(this.tabs);
            this.$store
                .dispatch(
                    "changeCustomPharmacyTabOrder",
                    this.tabs.map(tab => tab.id)
                )
                .then(result => {
                    console.log(result);
                }, this);
        },
        selectTab(tab) {
            console.log("changed to", tab);
            this.currentTab = tab;
        }
    }
};
</script>

<style scoped lang="scss">
#create-first {
    width: 340px;
    p {
        text-align: justify;
    }
}

#setting-area {
    display: flex;
    overflow-y: auto;
    overflow-x: hidden;
}

#form {
    margin-left: 30px;
}
.form-row {
    display: flex;
    flex-wrap: wrap;
}
.form-row > * {
    flex: 1;
    margin: 12px;
    min-width: 260px;
}
.list-group-item {
    cursor: pointer;
    display: flex;
    align-items: center;
}
.list-group-item > .tab-list-name {
    flex: 1;
}
.list-group-item.selected {
    background: $green;
}

.list-group-sorter-box {
    display: flex;
    flex-direction: column;
}
.list-group-sorter-start {
    color: $gray-lighter;
}
.list-group-sorter {
    margin: -3px;
}

.list-group-item.footer div {
    margin-left: calc(1em + 8px);
}
.list-group-item button {
    width: 100%;
}
</style>
